import { render, staticRenderFns } from "./SaleCard.vue?vue&type=template&id=291f96a5&scoped=true&"
import script from "./SaleCard.vue?vue&type=script&lang=js&"
export * from "./SaleCard.vue?vue&type=script&lang=js&"
import style0 from "./SaleCard.vue?vue&type=style&index=0&id=291f96a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f96a5",
  null
  
)

export default component.exports